import template from './synonym-api-form.html.twig';

const { Component, Mixin } = Shopware;

Component.register('topdata-es-synonym-api-form', {
    template,

    mixins: [
        Mixin.getByName('notification'),
    ],

    props: {
        entity: {
            type: Object,
            required: true,
        },
        repository: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            isLoading: false,
        };
    },

    computed: {
        isNew() {
            return this.entity.isNew();
        },
        modalTitle() {
            return this.isNew
                ? this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-api.modalTitleAdd')
                : this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-api.modalTitleEdit');
        },
    },

    methods: {
        onSave() {
            if (!this.entity.name.trim() || !this.entity.url.trim() || !this.entity.jsonPath.trim()) return;

            this.isLoading = true;
            this.repository.save(this.entity).then(() => {
                this.createNotificationSuccess({
                    message: this.$tc('TopdataEnhancedSearchSW6.topdata-es-synonym-api.saveSuccess'),
                });
                this.$emit('save', this.entity);
            }).catch(() => {
                this.isLoading = false;
            });
        },

        onCancel() {
            this.$emit('cancel');
        },
    },
});